export const WS_SUFFIX = {
  OAIBOX_TELEMETRY: 'telemetry',
  AI_RAN_TELEMETRY: 'ai-ran.telemetry',
  FLEX_RIC_TELEMETRY: 'flexric',
  GNB_CONFIGURATION: 'gnb.configuration',
}
